import { animatedPlayerIndex } from '@annunciate/core';
export const useAnimatedPlayerIndex = () => {
    return animatedPlayerIndex;
};
//# sourceMappingURL=useAnimatedPlayerIndex.js.map